import {
  AccountVestingSearchParamsV2,
  AccountVestingTypeV2,
  ApproveAccountVestingParamsV2,
  AxiosPagingResponse,
  SyncAccountVestingParamsV2,
} from 'Modules'
import queryString from 'query-string'

import { instance } from 'api-base/instance'

export const accountVestingV2Api = {
  getList(input: AccountVestingSearchParamsV2) {
    const path = queryString.stringifyUrl(
      {
        url: '/admin/account-vesting/ver2',
        query: { ...input },
      },
      { skipNull: true, skipEmptyString: true }
    )
    return instance.get<AxiosPagingResponse<AccountVestingTypeV2>>(path)
  },

  sync(input: SyncAccountVestingParamsV2) {
    return instance.post<any>('/admin/account-vesting/sync-ver2', input)
  },

  approve(input: ApproveAccountVestingParamsV2) {
    return instance.post<any>('/admin/account-vesting/approve-ver2', input)
  },
}
